/**
 * Converts camel case to snake case
 *
 * @param {string} variableName
 * @return string
 */
export const toSnakeCase = (variableName) => {
  let snakeCase = variableName;
  let underscores = 0;
  for (var i = 0; i < variableName.length; i++) {
    if (variableName[i] === variableName[i].toUpperCase()) {
      snakeCase = `${snakeCase.slice(0, i + underscores)}_${variableName
        .slice(i)
        .toLowerCase()}`;
      underscores++;
    }
  }
  return snakeCase;
};

/**
 * Prepares data for submission to the back end
 *
 * @param {} submitData
 */
export const prepareForSubmission = (submitData) => {
  const converted = {};
  Object.keys(submitData).forEach((formElement) => {
    converted[toSnakeCase(formElement)] = submitData[formElement];
  });
  return converted;
};
